module.exports = __webpack_public_path__ + "3e01cbb8c634f25dbca4065233cd4dd7.svg";